/**
 * The date calendar (./DateCalendar: react-day-picker, ~22 KB gzipped) is its
 * own chunk, fetched when a pointer or focus reaches a desktop field —
 * by the click it is there. Phones open the wheel sheet and never fetch it.
 * Same split as `./ml`.
 */
type CalendarModule = typeof import('./DateCalendar');

let loaded: CalendarModule | undefined;

/** The chunk once it has arrived, for a synchronous first render. */
export function loadedDateCalendar(): CalendarModule | undefined {
  return loaded;
}

export function loadDateCalendar(): Promise<CalendarModule> {
  return import('./DateCalendar').then((module) => (loaded = module));
}
